export const TREASURES_DB_KEY = 'treasures-1.8'
